import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "sub-table-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "sub-table-heading" }, "Список дашбордов", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  "data-segment": 1,
  class: "pi pi-ellipsis-v"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

import { ref, computed } from "vue";
import { useRouter } from "vue-router";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";

import { convertDateFromUTC } from "@/services/utils/DateParser";
import { getUserName } from "@/services/utils/Names";
import { useDashbordsStore } from "@/store/analytics/dasboards";
import { rootGetters } from "@/main";
import { useAuthStore } from "@/store/auth/login";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkbooksTable',
  props: {
    workbooks: {},
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable", "updateTable"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const router = useRouter();
const store = useDashbordsStore();
const authStore = useAuthStore();

let modifiedId = ref(0);
let modifiedEntity = ref("client_workbooks");
const confirmVisible = ref({
  delete: false,
  history: false,
});
const blockedButtonDelete = ref(false);
const menu = ref();
const menuDashboards = ref();
const expandedRows = ref({});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    archive: "no_archive",
    command: () => {
      router.push({ name: "workbook", params: { id: modifiedId.value } });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    archive: "both",
    command: () => {
      confirmVisible.value.delete = true;
    },
  },
]);

const dashboardsItems = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
]);

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const filtereddashboardsItems = computed(() => {
  return dashboardsItems.value.filter(
    (item) => !(item.checkDenied && isDenied.value)
  );
});

const toggle = (elemId: number, event: any) => {
  modifiedId.value = elemId;
  modifiedEntity.value = "client_workbooks";
  menu.value.toggle(event);
};

const toggleDashboards = (dashboardId: number, event: any) => {
  modifiedId.value = dashboardId;
  modifiedEntity.value = "dashboards";
  menuDashboards.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

const deleteWorkbook = () => {
  blockedButtonDelete.value = true;
  store
    .deleteWorkbook(modifiedId.value)
    .finally(() => {
      emits("updateTable");
      blockedButtonDelete.value = false;
      confirmVisible.value.delete = false;
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DataTable), {
      value: _ctx.workbooks,
      expandedRows: expandedRows.value,
      "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => ((expandedRows).value = $event)),
      class: _normalizeClass([[
      _ctx.workbooks && _ctx.workbooks.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
      stripedRows: "",
      onSort: sortTable,
      removableSort: "",
      scrollable: "",
      loading: _ctx.isLoading,
      dataKey: "id",
      columnResizeMode: "expand"
    }, {
      expansion: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(DataTable), {
            value: slotProps.data.dashboards,
            class: "sub-table"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Column), {
                field: "name",
                header: "Наименование дашборда"
              }),
              _createVNode(_unref(Column), {
                field: "datalens_id",
                header: "Datalens ID",
                sortable: ""
              }),
              _createVNode(_unref(Column), {
                field: "cuser__lname",
                header: "Пользователь",
                style: {"max-width":"150px"}
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.cuser)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(getUserName)(slotProps.data.cuser)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Column), {
                field: "ctime",
                header: "Дата создания",
                style: {"min-width":"153px"}
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(Column), {
                field: "mtime",
                header: "Дата обновления",
                style: {"min-width":"173px"}
              }, {
                body: _withCtx((slotPropsRole) => [
                  _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotPropsRole.data.mtime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                frozen: "",
                alignFrozen: "right"
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("div", {
                    onClick: (event) => toggleDashboards(slotProps.data.id, event),
                    "aria-haspopup": "true",
                    "aria-controls": "overlay_menu",
                    class: "button-menu"
                  }, _hoisted_12, 8, _hoisted_10)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["value"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          expander: "",
          style: {"min-width":"52px","max-width":"52px"}
        }),
        _createVNode(_unref(Column), {
          field: "number",
          header: "№",
          style: {"min-width":"44px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "name",
          header: "Наименование",
          sortable: "",
          style: {"min-width":"120px"}
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_RouterLink, {
              to: { name: 'workbook', params: { id: slotProps.data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(slotProps.data.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "tenant",
          header: "Тенант"
        }),
        _createVNode(_unref(Column), {
          field: "cuser__lname",
          header: "Пользователь"
        }, {
          body: _withCtx((slotProps) => [
            (slotProps.data.cuser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(getUserName)(slotProps.data.cuser)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "ctime",
          header: "Дата создания",
          sortable: "",
          style: {"min-width":"153px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "mtime",
          header: "Дата обновления",
          sortable: "",
          style: {"min-width":"173px"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(convertDateFromUTC)(slotProps.data.mtime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          frozen: "",
          alignFrozen: "right"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", {
              onClick: (event) => toggle(slotProps.data.id, event),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu",
              class: "button-menu"
            }, _hoisted_5, 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "expandedRows", "class", "loading"]),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      id: "overlay_menu",
      model: filteredItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(_unref(Menu), {
      ref_key: "menuDashboards",
      ref: menuDashboards,
      id: "overlay_menu",
      model: filtereddashboardsItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(DeleteConfirmDialog, {
      "deleted-name": "воркбук и все его дашборды",
      visible: confirmVisible.value.delete,
      blocked: blockedButtonDelete.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmVisible.value.delete = false)),
      onDelete: deleteWorkbook
    }, null, 8, ["visible", "blocked"]),
    _createVNode(UsersHistoryDialog, {
      entity: _unref(modifiedEntity),
      object_id: _unref(modifiedId),
      visible: confirmVisible.value.history,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (confirmVisible.value.history = false))
    }, null, 8, ["entity", "object_id", "visible"])
  ], 64))
}
}

})